import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#525252",
      d: "M3.411 20H16.59C18.87 20 20 18.881 20 16.643V3.368C20 1.13 18.87 0 16.589 0H3.41C1.141 0 0 1.13 0 3.368v13.275C0 18.881 1.14 20 3.411 20m.022-1.749c-1.086 0-1.684-.576-1.684-1.706V3.465c0-1.13.598-1.716 1.684-1.716h13.134c1.076 0 1.684.587 1.684 1.717v13.08c0 1.13-.608 1.705-1.684 1.705z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#525252",
      d: "M4.204 16.774h2.369c.695 0 .977-.272.977-.946V4.193c0-.684-.282-.956-.977-.956H4.204c-.695 0-.977.272-.977.956v11.635c0 .674.282.946.977.946"
    }, null, -1)
  ])))
}
export default { render: render }